// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"e8618653","835":"0890e2ee","947":"be77114e"}[chunkId] + ".chunk.css";
};